import { ChangeEvent, FC } from 'react';
import { Select, SelectProps } from '@chakra-ui/react';

import { EventType } from '../../../graphql/generated';

type Props = Omit<SelectProps, 'onChange'> & {
  onChange: (type: EventType) => void;
};

const eventTypeLabelMap: Record<EventType, string> = {
  [EventType.FILE_ARCHIVED]: 'Archived',
  [EventType.FILE_CREATED]: 'Uploads',
  [EventType.FILE_DOWNLOADED]: 'Downloads',
  [EventType.FILE_DELETED]: 'Deletes',
  [EventType.FILE_UPDATED]: 'Revisions',
  [EventType.FOLDER_CREATED]: 'New Folder',
  [EventType.FOLDER_DOWNLOADED]: 'Folder Downloads',
  [EventType.PII_APPROVED]: 'PII Approvals',
  [EventType.FILE_MOVED]: 'Moves',
  [EventType.FILE_RENAMED]: 'Renames',
};

export const FileActivityListFilters: FC<Props> = ({ onChange, ...rest }) => {
  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedEventType = e.target.value as EventType;

    onChange(selectedEventType);
  };

  return (
    <Select
      onChange={handleChange}
      placeholder="All events"
      data-testid="file-activity-type-filter"
      {...rest}
    >
      {Object.entries(eventTypeLabelMap).map(([key, value]) => (
        <option key={key} value={key}>
          {value}
        </option>
      ))}
    </Select>
  );
};
